import { LAST_SET_SPELLCHECKER_LANG_LS_KEY } from 'src/app/shared/components/single-message-editor/codemirror-spellchecker/codemirror-spellchecker';

export function questionEdition() {
  return {
    restrict: 'E',
    template: require('./question-edition.directive.html'),
    scope: {
      question: '=',
      editorModelAccessor: '<',
      isRoot: '<',
      isMessageWithChoice: '<',
      isQuestionBox: '<',
      quickRepliesElementsConfig: '<',
      questionTextIsEmpty: '=',
      companyId: '<',
      site: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope', 'MediasFactory', 'AlertingFactory', 'LocalStorageFactory', 'WhatsappFactory', 'AngularTranslateService']
function controller($scope, MediasFactory, AlertingFactory, LocalStorageFactory, WhatsappFactory, AngularTranslateService) {

  $scope.removeMedia = removeMedia;
  $scope.messageTypeChanged = messageTypeChanged;

  $scope.showTextComposer = true;
  $scope.showMediaContent = true;
  $scope.isWhatsappAccount = $scope.site.type === WhatsappFactory.getType();
  $scope.messageType = null;
  $scope.messageTypes = [
    { id: 'text', label: AngularTranslateService.instant('parameters/quick_replies/details/graph/whatsapp-message-type/text') },
    { id: 'media', label: AngularTranslateService.instant('parameters/quick_replies/details/graph/whatsapp-message-type/media') },
  ];

  (function init() {
    const { pictureId, videoId } = $scope.question;
    const mediaMessageType = pictureId || videoId;
    $scope.showTextComposer = !$scope.isWhatsappAccount || !mediaMessageType;
    $scope.showMediaContent = !$scope.isWhatsappAccount || mediaMessageType;
    $scope.messageType = $scope.showTextComposer ? 'text' : 'media';

    $scope.pictureFile = null;
    $scope.videoFile = null;
    if ($scope.question.pictureId) {
      $scope.mediaUrl = MediasFactory.pictureUrl($scope.companyId, $scope.question.pictureId);
    }
    else if ($scope.question.videoId) {
      $scope.mediaUrl = MediasFactory.videoUrl($scope.companyId, $scope.question.videoId);
    }
    $scope.loading = false;
    $scope.initialEditorModel = {
      'text': $scope.question.content,
      'links': $scope.question.links
    };
    if ($scope.question.fileId) {
      $scope.initialEditorModel.attachments = [{
        type: 'file',
        value: {
          fileId: $scope.question.fileId,
          fileName: $scope.question.fileName
        }
      }]
    }
    if (!$scope.question.spellCheckerLang) {
      $scope.question.spellCheckerLang = LocalStorageFactory.getItem(LAST_SET_SPELLCHECKER_LANG_LS_KEY) || 'fr';
    }
    $scope.editorConfiguration = {
      ...$scope.quickRepliesElementsConfig.editorConfiguration,
      lang: $scope.question.spellCheckerLang,
    };

    $scope.$watch('editorConfiguration.lang', function (newLang) {
      if (newLang) {
        // propagate selected spellchecker lang to QuestionBox
        $scope.question.spellCheckerLang = newLang;
      }
    });


    $scope.menuChoices = [
      {
        id: 1,
        label: '1, 2, 3, ...'
      },
      {
        id: 2,
        label: 'A, B, C, ...'
      }
    ];


  })();

  $scope.$watch('pictureFile', function (newFile, oldFile) {
    if (newFile) {
      uploadMedia(newFile, 'image', false);
    }
  });

  $scope.$watch('videoFile', function (newFile, oldFile) {
    if (newFile) {
      uploadMedia(newFile, 'video', true);
    }
  });

  function messageTypeChanged(value) {
    removeMedia();
    $scope.initialEditorModel = {
      text: '',
      links: undefined
    };
    $scope.question.fileId = undefined;
    $scope.showTextComposer = value === 'text';
    $scope.showMediaContent = value === 'media';
  }

  function removeMedia() {
    $scope.question.pictureId = undefined;
    $scope.question.videoId = undefined;
    $scope.mediaUrl = undefined;
  }

  function controlImage(imageSize, imageHeight, imageWidth) {
    AlertingFactory.notify.config({ duration: 10000 }); //Increase alert duration temporarily

    if ($scope.isQuestionBox) {
      const imageRatio = imageWidth / imageHeight;
      const imageMinRatio = $scope.quickRepliesElementsConfig.editorConfiguration.imageMinRatio;
      const imageMaxRatio = $scope.quickRepliesElementsConfig.editorConfiguration.imageMaxRatio;

      const isRatioValid = imageMinRatio <= imageRatio && imageRatio <= imageMaxRatio;
      const isWidthValid = imageWidth >= $scope.quickRepliesElementsConfig.editorConfiguration.imageMinWidth;
      const isSizeValid = imageSize <= $scope.quickRepliesElementsConfig.editorConfiguration.imageMaxSizekb * 1000;

      if (!isWidthValid) {
        AlertingFactory.error('parameters/quick_replies/details/edit_question/image_size_ratio_restriction/kakaotalk/error/width');
      }
      if (!isSizeValid) {
        AlertingFactory.error('parameters/quick_replies/details/edit_question/image_size_ratio_restriction/kakaotalk/error/size');
      }
      if (!isRatioValid) {
        AlertingFactory.error('parameters/quick_replies/details/edit_question/image_size_ratio_restriction/kakaotalk/error/ratio');
      }
      if (!isRatioValid || !isWidthValid || !isSizeValid) {
        AlertingFactory.error('parameters/quick_replies/details/edit_question/image_size_ratio_restriction/kakaotalk/error');
      }
    }
    AlertingFactory.notify.config({ duration: 4000 }); //Reset alert duration
  }

  function initImageControl(newFile) {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      // convert image file to base64 string
      const image = new Image();
      image.onload = () => {
        controlImage($scope.pictureFile.size, image.height, image.width);
      };
      image.src = reader.result;
    }, false);
    reader.readAsDataURL(newFile);
  }

  function uploadMedia(file, mediaType, uploadAsync) {
    if ($scope.quickRepliesElementsConfig.editorConfiguration.hasImageControl) {
      initImageControl(file);
    }
    $scope.loading = true;
    MediasFactory.checkLimitationsAndUpload({
      companyId: $scope.companyId,
      siteId: $scope.site.id,
      mediaType,
      file,
      mediaLimitations: $scope.quickRepliesElementsConfig,
      uploadAsync
    }, function (response) {
      $scope.loading = false;
      if (mediaType === 'image') {
        $scope.question.pictureId = response.data.media_id;
        $scope.question.videoId = null;
        $scope.mediaUrl = MediasFactory.pictureUrl($scope.companyId, $scope.question.pictureId);
      }
      else {
        $scope.question.pictureId = null;
        $scope.question.videoId = response.data.media_id;
        $scope.mediaUrl = MediasFactory.videoUrl($scope.companyId, $scope.question.videoId);
      }


    }, function (response) {
      $scope.loading = false;
      if (!angular.isUndefined(response.data.error_translation)) {
        AlertingFactory.error(response.data.error_translation, { noTranslation: true });
      } else {
        AlertingFactory.alertHTTPError(response);
      }
    });
  }
}
